let AdContent = {
    "eng": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "back",
        "icons": {
            "icon-1": "shoot",
            "icon-2": "kick ups",
            "icon-3": "save"
        },
        "intro": {
            "summary": [
                "where there's a pitch,",
                "there's a legend.",
                "pick your challenge.",
                "prove your skills."
            ],
        },
        "demo-shoot": {
            "slogan": "PICK YOUR SPOT.<br>SWIPE TO SHOOT.",
            "cta": "play now"
        },
        "demo-kickup": {
            "slogan": "HOW MANY KICK UPS CAN<br>YOU DO IN 15 SECONDS?",
            "slogan2": "TAP WHEN THE BALL HITS THE FOOT.<br>KEEP IT IN THE AIR.",
            "cta": "play now",
            "your-score": "Your Score",
        },
        "demo-save": {
            "slogan": "You’re the goalkeeper.<br>Tap to make the save.",
            "slogan2": "CHOOSE YOUR SPOT<br>BEFORE THE SHOT.",
            "cta": "play now",
            "continue": "Continue"
        },
        "game-shoot": {
            "instruction": "PICK YOUR SPOT. SWIPE TO SHOOT.",
            "goal-callout": "Goal!",
            "miss-callout": "MISS",
            "sub-title": "YOUR SCORE",
            "circle-goal": "GOAL",
            "circle-miss": "MISS",
            "continue": "CONTINUE"
        },
        "game-dribble": {
            "continue": "Continue",
            "sub-title": "Your Score",
            "instruction": "TIME YOUR TAP."
        },
        "game-save": {
            "sub-title": "YOUR SCORE",
            "goal-callout": "TRY AGAIN",
            "save-callout": "SAVE!",
            "circle-goal": "GOAL",
            "circle-save": "SAVE",
            "status-save": "SAVE!",
            "status-goal": "GOAL",
            "continue": "CONTINUE",
            "instruction": "CHOOSE YOUR SPOT BEFORE THE SHOOT.",
            "your-score": "Your Score",
        },
        "outro": {
            "title": "WHERE THERE'S A PITCH,<br>THERE'S A LEGEND.",
            "sub-title": "PLAY AGAIN OR TRY A NEW CHALLENGE",
            "social-title": "CHALLENGE YOUR FRIENDS",
            "score-legend": "Legend Score"
        },
        'share-message': `Prove your skill and show what you’ve got—join adidas in "The Yard" and try to beat my score. Legend Score to beat: $$$ #YouGotThis`,
        'share-url': 'https://www.adidaslegends.com/',
        'exit-url': 'https://www.adidaslegends.com/',
        'share-graphics': "images/pack-{pack}/share-eng.jpg"
    },
     "eng-swi": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "back",
        "icons": {
            "icon-1": "shoot",
            "icon-2": "kick ups",
            "icon-3": "save"
        },
        "intro": {
            "summary": [
                "where there's a pitch,",
                "there's a legend.",
                "pick your challenge.",
                "prove your skills."
            ],
        },
        "demo-shoot": {
            "slogan": "PICK YOUR SPOT.<br>SWIPE TO SHOOT.",
            "cta": "play now"
        },
        "demo-kickup": {
            "slogan": "HOW MANY KICK UPS CAN<br>YOU DO IN 15 SECONDS?",
            "slogan2": "TAP WHEN THE BALL HITS THE FOOT.<br>KEEP IT IN THE AIR.",
            "cta": "play now",
            "your-score": "Your Score",
        },
        "demo-save": {
            "slogan": "You’re the goalkeeper.<br>Tap to make the save.",
            "slogan2": "CHOOSE YOUR SPOT<br>BEFORE THE SHOT.",
            "cta": "play now",
            "continue": "Continue"
        },
        "game-shoot": {
            "instruction": "PICK YOUR SPOT. SWIPE TO SHOOT.",
            "goal-callout": "Goal!",
            "miss-callout": "MISS",
            "sub-title": "YOUR SCORE",
            "circle-goal": "GOAL",
            "circle-miss": "MISS",
            "continue": "CONTINUE"
        },
        "game-dribble": {
            "continue": "Continue",
            "sub-title": "Your Score",
            "instruction": "TIME YOUR TAP."
        },
        "game-save": {
            "sub-title": "YOUR SCORE",
            "goal-callout": "TRY AGAIN",
            "save-callout": "SAVE!",
            "circle-goal": "GOAL",
            "circle-save": "SAVE",
            "status-save": "SAVE!",
            "status-goal": "GOAL",
            "continue": "CONTINUE",
            "instruction": "CHOOSE YOUR SPOT BEFORE THE SHOOT.",
            "your-score": "Your Score",
        },
        "outro": {
            "title": "WHERE THERE'S A PITCH,<br>THERE'S A LEGEND.",
            "sub-title": "PLAY AGAIN OR TRY A NEW CHALLENGE",
            "social-title": "CHALLENGE YOUR FRIENDS",
            "score-legend": "Legend Score"
        },
        'share-message': `Prove your skill and show what you’ve got—join adidas in "The Yard" and try to beat my score. Legend Score to beat: $$$ #YouGotThis`,
        'share-url': 'https://www.adidaslegends.com/',
        'exit-url': 'https://www.adidaslegends.com/',
        'share-graphics': "images/pack-{pack}/share-eng.jpg"
    },
     "eng-bel": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "back",
        "icons": {
            "icon-1": "shoot",
            "icon-2": "kick ups",
            "icon-3": "save"
        },
        "intro": {
            "summary": [
                "where there's a pitch,",
                "there's a legend.",
                "pick your challenge.",
                "prove your skills."
            ],
        },
        "demo-shoot": {
            "slogan": "PICK YOUR SPOT.<br>SWIPE TO SHOOT.",
            "cta": "play now"
        },
        "demo-kickup": {
            "slogan": "HOW MANY KICK UPS CAN<br>YOU DO IN 15 SECONDS?",
            "slogan2": "TAP WHEN THE BALL HITS THE FOOT.<br>KEEP IT IN THE AIR.",
            "cta": "play now",
            "your-score": "Your Score",
        },
        "demo-save": {
            "slogan": "You’re the goalkeeper.<br>Tap to make the save.",
            "slogan2": "CHOOSE YOUR SPOT<br>BEFORE THE SHOT.",
            "cta": "play now",
            "continue": "Continue"
        },
        "game-shoot": {
            "instruction": "PICK YOUR SPOT. SWIPE TO SHOOT.",
            "goal-callout": "Goal!",
            "miss-callout": "MISS",
            "sub-title": "YOUR SCORE",
            "circle-goal": "GOAL",
            "circle-miss": "MISS",
            "continue": "CONTINUE"
        },
        "game-dribble": {
            "continue": "Continue",
            "sub-title": "Your Score",
            "instruction": "TIME YOUR TAP."
        },
        "game-save": {
            "sub-title": "YOUR SCORE",
            "goal-callout": "TRY AGAIN",
            "save-callout": "SAVE!",
            "circle-goal": "GOAL",
            "circle-save": "SAVE",
            "status-save": "SAVE!",
            "status-goal": "GOAL",
            "continue": "CONTINUE",
             "instruction": "CHOOSE YOUR SPOT BEFORE THE SHOOT.",
            "your-score": "Your Score",
        },
        "outro": {
            "title": "WHERE THERE'S A PITCH,<br>THERE'S A LEGEND.",
            "sub-title": "PLAY AGAIN OR TRY A NEW CHALLENGE",
            "social-title": "CHALLENGE YOUR FRIENDS",
            "score-legend": "Legend Score"
        },
        'share-message': `Prove your skill and show what you’ve got—join adidas in "The Yard" and try to beat my score. Legend Score to beat: $$$ #YouGotThis`,
        'share-url': 'https://www.adidaslegends.com/',
        'exit-url': 'https://www.adidaslegends.com/',
        'share-graphics': "images/pack-{pack}/share-eng.jpg"
    },
    'fre': {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "RETOUR",
        "icons": {
            "icon-1": "TIRER",
            "icon-2": "JONGLER",
            "icon-3": "ARRÊTER"
        },
        "intro": {
            "summary": [
                "À CHAQUE TERRAIN,",
                "SA LÉGENDE.",
                "CHOISIS TON DÉFI.",
                "MONTRE TON NIVEAU."
            ],
        },
        "demo-shoot": {
            "slogan": "CHOISIS UN CÔTÉ.<br>SWIPE POUR TIRER.",
            "cta": "JOUER MAINTENANT"
        },
        "demo-kickup": {
            "slogan": "COMBIEN DE JONGLES PEUX-TU<br>FAIRE EN 15 SECONDES ?",
            "slogan2": "APPUIE QUAND LE BALLON TOUCHE LE PIED.<br>GARDE-LE EN L'AIR.",
            "cta": "JOUER MAINTENANT"
        },
        "demo-save": {
            "slogan": "TU ES LE GARDIEN DE BUT.<br>APPUIE POUR FAIRE UN ARRÊT.",
            "slogan2": "CHOISIS TON CÔTÉ AVANT LE TIR.",
            "cta": "JOUER MAINTENANT"
        },
        "game-shoot": {
            "instruction": "CHOISIS TON CÔTÉ. SWIPE POUR TIRER.",
            "goal-callout": "But!",
            "miss-callout": "RATÉ",
            "sub-title": "TON SCORE",
            "circle-goal": "BUT",
            "circle-miss": "RATÉ",
            "continue": "CONTINUER"
        },
        "game-dribble": {
            "continue": "CONTINUER",
            "sub-title": "Ton Score",
            "instruction": "APPUIE AU BON MOMENT."
        },
        "game-save": {
            "sub-title": "TON SCORE",
            "goal-callout": "RÉESSAIE",
            "save-callout": "ARRÊTÉ!",
            "circle-goal": "BUT",
            "circle-save": "ARRÊTÉ",
            "status-save": "ARRÊTÉ",
            "status-goal": "BUT",
            "continue": "CONTINUER",
            "instruction": "CHOISIS TON CÔTÉ AVANT LE TIR.",
            "your-score": "TON SCORE"
        },
        "outro": {
            "title": "À CHAQUE TERRAIN,<br>SA LÉGENDE.",
            "sub-title": "REJOUE OU TENTE UN NOUVEAU DÉFI",
            "social-title": "DÉFIE TES AMIS",
            "score-legend": "Score légendaire"
        },
        "share-message": `Tu as été défié ! Prouve ton talent et montre ce que tu sais faire — rejoins adidas au "City" et essaie de battre mon score. Score Légendaire à battre : $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-fre.jpg"
    },
    "ger": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "ZURÜCK",
        "icons": {
            "icon-1": "SCHUSS",
            "icon-2": "BALL JONGLIEREN",
            "icon-3": "PARADE"
        },
        "intro": {
            "summary": [
                "WO ES EINEN PLATZ GIBT,",
                "GIBT ES EINE LEGENDE.",
                "WÄHL DEINE HERAUSFORDERUNG.",
                "BEWEISE DEIN KÖNNEN."
            ],
        },
        "demo-shoot": {
            "slogan": "WÄHLE EINE SEITE.<br>SWIPE UM ZU SCHIESSEN.",
            "cta": "JETZT SPIELEN"
        },
        "demo-kickup": {
            "slogan": "WIE OFT KANNST DU DEN BALL<br>IN 15 SEKUNDEN JONGLIEREN?",
            "slogan2": "TIPPE WENN DER BALL DEN FUSS BERÜHRT.<br>HALT IHN IN DER LUFT.",
            "cta": "JETZT SPIELEN"
        },
        "demo-save": {
            "slogan": "DU BIST DER TORWART.<br>TIPPE UM EINE PARADE <br>ZU MACHEN.",
            "slogan2": "WÄHLE DEINE SEITE VOR<br>DEM SCHUSS.",
            "cta": "JETZT SPIELEN"
        },
        "game-shoot": {
            "instruction": "WÄHLE EINE SEITE. SWIPE UM ZU SCHIESSEN.",
            "goal-callout": "Tor!",
            "miss-callout": "DANEBEN",
            "sub-title": "DEIN ERGEBNIS",
            "circle-goal": "TOR",
            "circle-miss": "DANEBEN",
            "continue": "WEITER"
        },
        "game-dribble": {
            "continue": "WEITER",
            "sub-title": "Dein Ergebnis",
            "instruction": "TRIFF DEN MOMENT."
        },
        "game-save": {
            "sub-title": "DEIN ERGEBNIS",
            "goal-callout": "NOCHMAL<br>VERSUCHEN",
            "save-callout": "PARADE!",
            "circle-goal": "TOR",
            "circle-save": "PARADE",
            "status-save": "PARADE",
            "status-goal": "TOR",
            "continue": "WEITER",
            "instruction": "WÄHLE DEINE SEITE VOR DEM SCHUSS.",
            "your-score": "DEIN ERGEBNIS"
        },
        "outro": {
            "title": "WO ES EINEN PLATZ GIBT,<br>GIBT ES EINE LEGENDE.",
            "sub-title": "SPIEL NOCHMAL ODER<br>VERSUCH EINE NEUE HERAUSFORDERUNG.",
            "social-title": "FORDERE DEINE<br>FREUNDE HERAUS",
            "score-legend": "Legenden-Score"
        },
        "share-message": `Du wurdest herausgefordert! Beweise dein Können und zeig was du drauf hast—spiel adidas' "You Got This" und versuch meinen Score zu überbieten. Legenden-Score zu schlagen: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-ger.jpg"
    },
    "ger-aus": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "ZURÜCK",
        "icons": {
            "icon-1": "SCHUSS",
            "icon-2": "BALL JONGLIEREN",
            "icon-3": "PARADE"
        },
        "intro": {
            "summary": [
                "WO ES EINEN PLATZ GIBT,",
                "GIBT ES EINE LEGENDE.",
                "WÄHL DEINE HERAUSFORDERUNG.",
                "BEWEISE DEIN KÖNNEN."
            ],
        },
        "demo-shoot": {
            "slogan": "WÄHLE EINE SEITE.<br>SWIPE UM ZU SCHIESSEN.",
            "cta": "JETZT SPIELEN"
        },
        "demo-kickup": {
            "slogan": "WIE OFT KANNST DU DEN BALL<br>IN 15 SEKUNDEN JONGLIEREN?",
            "slogan2": "TIPPE WENN DER BALL DEN FUSS BERÜHRT.<br>HALT IHN IN DER LUFT.",
            "cta": "JETZT SPIELEN"
        },
        "demo-save": {
            "slogan": "DU BIST DER TORWART.<br>TIPPE UM EINE PARADE <br>ZU MACHEN.",
            "slogan2": "WÄHLE DEINE SEITE VOR<br>DEM SCHUSS.",
            "cta": "JETZT SPIELEN"
        },
        "game-shoot": {
            "instruction": "WÄHLE EINE SEITE. SWIPE UM ZU SCHIESSEN.",
            "goal-callout": "Tor!",
            "miss-callout": "DANEBEN",
            "sub-title": "DEIN ERGEBNIS",
            "circle-goal": "TOR",
            "circle-miss": "DANEBEN",
            "continue": "WEITER"
        },
        "game-dribble": {
            "continue": "WEITER",
            "sub-title": "Dein Ergebnis",
            "instruction": "TRIFF DEN MOMENT."
        },
        "game-save": {
            "sub-title": "DEIN ERGEBNIS",
            "goal-callout": "NOCHMAL<br>VERSUCHEN",
            "save-callout": "PARADE!",
            "circle-goal": "TOR",
            "circle-save": "PARADE",
            "status-save": "PARADE",
            "status-goal": "TOR",
            "continue": "WEITER",
            "instruction": "WÄHLE DEINE SEITE VOR DEM SCHUSS.",
            "your-score": "DEIN ERGEBNIS"
        },
        "outro": {
            "title": "WO ES EINEN PLATZ GIBT,<br>GIBT ES EINE LEGENDE.",
            "sub-title": "SPIEL NOCHMAL ODER<br>VERSUCH EINE NEUE HERAUSFORDERUNG.",
            "social-title": "FORDERE DEINE<br>FREUNDE HERAUS",
            "score-legend": "Legenden-Score"
        },
        "share-message": `Du wurdest herausgefordert! Beweise dein Können und zeig was du drauf hast—spiel adidas' "You Got This" und versuch meinen Score zu überbieten. Legenden-Score zu schlagen: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-ger.jpg"
    },

    "spa": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "VOLVER",
        "icons": {
            "icon-1": "TIRO",
            "icon-2": "TOQUES",
            "icon-3": "PARADA"
        },
        "intro": {
            "summary": [
                "Cada terreno de juego",
                "tiene su propia leyenda",
                "ELIGE TU RETO.",
                "DEMUESTRA TU NIVEL."
            ],
        },
        "demo-shoot": {
            "slogan": "ELIGE TU PUNTO.<br>DESLIZA PARA TIRAR.",
            "cta": "JUGAR AHORA"
        },
        "demo-kickup": {
            "slogan": "¿CUÁNTOS TOQUES PUEDES<br>HACER EN 15 SEGUNDOS?",
            "slogan2": "TOCA CUANDO EL BALÓN TOQUE EL PIE.<br>MANTENLO EN EL AIRE.",
            "cta": "JUGAR AHORA"
        },
        "demo-save": {
            "slogan": "ERES EL PORTERO.<br>TOCA PARA HACER LA PARADA.",
            "slogan2": "ELIGE TU PUNTO<br>ANTES DEL TIRO",
            "cta": "JUGAR AHORA"
        },
        "game-shoot": {
            "instruction": "ELIGE TU PUNTO. DESLIZA PARA TIRAR.",
            "goal-callout": "¡Gol!",
            "miss-callout": "FALLADO",
            "sub-title": "TU PUNTUACIÓN",
            "circle-goal": "Gol",
            "circle-miss": "FALLADO",
            "continue": "CONTINUAR"
        },
        "game-dribble": {
            "continue": "CONTINUAR",
            "sub-title": "Tu Puntuación",
            "instruction": "ENCUENTRA EL MOMENTO."
        },
        "game-save": {
            "sub-title": "TU PUNTUACIÓN",
            "goal-callout": "INTÉNTALO<br>DE NUEVO",
            "save-callout": "¡PARADA!",
            "circle-goal": "GOL",
            "circle-save": "PARADA",
            "status-save": "PARADA",
            "status-goal": "GOL",
            "continue": "CONTINUAR",
            "instruction": "ELIGE TU PUNTO ANTES DEL TIRO.",
            "your-score": "TU PUNTUACIÓN"
        },
        "outro": {
            "title": "CADA TERRENO DE JUEGO  TIENE<br>SU PROPIA LEYENDA.",
            "sub-title": "JUEGA DE NUEVO O PRUEBA UN NUEVO RETO",
            "score-legend": "Puntuación Leyenda",
            "social-title": "DESAFÍA A TUS AMIGOS"
        },
        "share-message": `¡Te han desafiado! Demuestra tu habilidad y enseña de lo que eres capaz: únete a adidas en The Yard e intenta superar mi puntuación. Puntuación Leyenda a batir: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-spa.jpg"
    },
    "por": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "VOLTAR",
        "icons": {
            "icon-1": "REMATE",
            "icon-2": "TOQUES",
            "icon-3": "DEFESA"
        },
        "intro": {
            "summary": [
                "ONDE HÁ UM CAMPO,",
                "HÁ UMA LENDA.",
                "ESCOLHE O TEU DESAFIO.",
                "PROVA AS TUAS HABILIDADES."
            ],
        },
        "demo-shoot": {
            "slogan": "ESCOLHE O TEU ALVO.<br>DESLIZA PARA REMATAR. ",
            "cta": "JOGAR AGORA"
        },
        "demo-kickup": {
            "slogan": "QUANTOS TOQUES CONSEGUES<br>FAZER EM 15 SEGUNDOS?",
            "slogan2": "TOCA QUANDO A BOLA TOCAR NO PÉ.<br>MANTÉM-NA NO AR.",
            "cta": "JOGAR AGORA"
        },
        "demo-save": {
            "slogan": `ÉS O GUARDA-REDES.<br>TOCA PARA DEFENDER.`,
            "slogan2": "ESCOLHE O LADO<br>ANTES DO REMATE.",
            "cta": "JOGAR AGORA"
        },
        "game-shoot": {
            "instruction": "ESCOLHE O TEU ALVO. DESLIZA PARA REMATAR.",
            "goal-callout": "Golo!",
            "miss-callout": "FALHA",
            "sub-title": "PONTUAÇÃO",
            "circle-goal": "Golo",
            "circle-miss": "FALHA",
            "continue": "CONTINUAR"
        },
        "game-dribble": {
            "continue": "CONTINUAR",
            "sub-title": "Pontuação",
            "instruction": "CRONÓMETRO."
        },
        "game-save": {
            "sub-title": "PONTUAÇÃO",
            "goal-callout": "TENTA DE<br>NOVO",
            "save-callout": "DEFESA!",
            "circle-goal": "GOLO",
            "circle-save": "DEFESA",
            "status-save": "DEFESA",
            "status-goal": "GOLO",
            "continue": "CONTINUAR",
            "instruction": "ESCOLHE O TEU ALVO ANTES DO REMATE.",
            "your-score": "PONTUAÇÃO"
        },
        "outro": {
            "title": "ONDE HÁ UM CAMPO,<br>HÁ UMA LENDA.",
            "sub-title": "JOGA OUTRA VEZ OU TENTA UM NOVO DESAFIO.",
            "social-title": "DESAFIA OS TEUS AMIGOS",
            "score-legend": "Pontuação Lenda"
        },
        "share-message": `Foste desafiado! Prova a tua habilidade e mostra o que vales — junta-te à adidas em campo e tenta bater o meu score. Pontuação Lenda a bater: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-por.jpg"
    },
    "swe": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "TILLBAKA",
        "icons": {
            "icon-1": "SKOTT",
            "icon-2": "JONGLERING",
            "icon-3": "RÄDDNING"
        },
        "intro": {
            "summary": [
                "DÄR DET FINNS EN FOTBOLLSPLAN,",
                "FINNS DET EN LEGEND.",
                "VÄLJ DIN UTMANING.",
                "VISA VAD DU KAN."
            ],
        },
        "demo-shoot": {
            "slogan": "VÄLJ DIN PUNKT.<br>SVEP FÖR ATT SKJUTA.",
            "cta": "SPELA NU"
        },
        "demo-kickup": {
            "slogan": "HUR MÅNGA JONGLERINGAR KAN<br>DU GÖRA PÅ 15 SEKUNDER?",
            "slogan2": "TRYCK NÄR BOLLEN TRÄFFAR FOTEN.<br>HÅLL DEN I LUFTEN.",
            "cta": "SPELA NU"
        },
        "demo-save": {
            "slogan": "DU ÄR MÅLVAKTEN.<br>TRYCK FÖR ATT GÖRA<br>RÄDDNINGEN.",
            "slogan2": "VÄLJ DIN PUNKT<br>INNAN SKOTTET",
            "cta": "SPELA NU"
        },
        "game-shoot": {
            "instruction": "VÄLJ DIN PUNKT. SVEP FÖR ATT SKJUTA.",
            "goal-callout": "Mål!",
            "miss-callout": "MISS",
            "sub-title": "DIN POÄNG",
            "circle-goal": "MÅL",
            "circle-miss": "MISS",
            "continue": "FORTSÄTT"
        },
        "game-dribble": {
            "continue": "FORTSÄTT",
            "sub-title": "Din Poäng",
            "instruction": "TAJMA TRYCKET."
        },
        "game-save": {
            "sub-title": "DIN POÄNG",
            "goal-callout": "FÖRSÖK IGEN",
            "save-callout": "RÄDDNING!",
            "circle-goal": "MÅL",
            "circle-save": "RÄDDNING",
            "status-save": "RÄDDNING",
            "status-goal": "MÅL",
            "continue": "FORTSÄTT",
            "instruction": "VÄLJ DIN PUNKT INNAN SKOTTET.",
            "your-score": "DIN POÄNG"
        },
        "outro": {
            "title": "DÄR DET FINNS<br>EN FOTBOLLSPLAN,<br>FINNS DET EN LEGEND.",
            "sub-title": "SPELA IGEN ELLER PROVA EN NY UTMANING.",
            "social-title": "UTMANA DINA VÄNNER",
            "score-legend": "Legendpoäng"
        },
        "share-message": `Du har blivit utmanad! Visa vad du går för—spela adidas "You Got This" och försök slå mitt resultat. Legendpoäng att slå: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-swe.jpg"
    },
    "pol": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "WSTECZ",
        "icons": {
            "icon-1": "STRZAŁ",
            "icon-2": "ŻONGLERKA",
            "icon-3": "OBRONA"
        },
        "intro": {
            "summary": [
                "TAM GDZIE JEST BOISKO,<br>JEST LEGENDA.",
                "",
                "WYBIERZ SWOJE WYZWANIE. UDOWODNIJ SWOJE UMIEJĘTNOŚCI."
            ],
        },
        "demo-shoot": {
            "slogan": "WYBIERZ SWOJE MIEJSCE.<br>PRZESUŃ ABY STRZELIĆ.",
            "cta": "GRAJ TERAZ"
        },
        "demo-kickup": {
            "slogan": "ILE ŻONGLEREK ZROBISZ<br>W 15 SEKUND?",
            "slogan2": "DOTKNIJ GDY PIŁKA DOTKNIE STOPY.<br>UTRZYMAJ JĄ W POWIETRZU.",
            "cta": "GRAJ TERAZ"
        },
        "demo-save": {
            "slogan": "JESTEŚ BRAMKARZEM.<br>DOTKNIJ ABY OBRONIĆ.",
            "slogan2": "WYBIERZ SWOJE MIEJSCE<br>PRZED STRZAŁEM.",
            "cta": "GRAJ TERAZ"
        },
        "game-shoot": {
            "instruction": "WYBIERZ SWOJE MIEJSCE. PRZESUŃ ABY STRZELIĆ.",
            "goal-callout": "Gol!",
            "miss-callout": "PUDŁO",
            "sub-title": "TWÓJ WYNIK",
            "circle-goal": "GOL",
            "circle-miss": "PUDŁO",
            "continue": "DALEJ"
        },
        "game-dribble": {
            "continue": "DALEJ",
            "sub-title": "Twój Wynik",
            "instruction": "WYCZUJ MOMENT."
        },
        "game-save": {
            "sub-title": "TWÓJ WYNIK",
            "goal-callout": "SPRÓBUJ<br>JESZCZE RAZ",
            "save-callout": "OBRONA!",
            "circle-goal": "GOL",
            "circle-save": "OBRONA",
            "status-save": "OBRONA",
            "status-goal": "GOL",
            "continue": "DALEJ",
            "instruction": "WYBIERZ SWOJE MIEJSCE PRZED STRZAŁEM.",
            "your-score": "TWÓJ WYNIK"
        },
        "outro": {
            "title": "TAM GDZIE JEST BOISKO,<br>JEST LEGENDA.",
            "sub-title": "ZAGRAJ JESZCZE RAZ LUB SPRÓBUJ<br>NOWEGO WYZWANIA",
            "social-title": "WYZWIJ SWOICH PRZYJACIÓŁ",
            "score-legend": "Wynik Legendy"
        },
        "share-message": `Zostałeś wyzwany! Udowodnij swoje umiejętności i pokaż na co cię stać—zagraj w "You Got This" adidas i spróbuj pobić mój wynik. Wynik Legendy do pobicia: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-pol.jpg"
    },
    "rom": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "ÎNAPOI",
        "icons": {
            "icon-1": "ȘUTEAZĂ",
            "icon-2": "JONGLEAZĂ",
            "icon-3": "APĂRĂ"
        },
        "intro": {
            "summary": [
                "UNDE EXISTĂ UN TEREN,",
                "EXISTĂ O LEGENDĂ.",
                "ALEGE-ȚI PROVOCAREA ȘI",
                "DOVEDEȘTE-ȚI ABILITĂȚILE."
            ],
        },
        "demo-shoot": {
            "slogan": "ALEGE-ȚI POZIȚIA.<br>GLISEAZĂ PENTRU A ȘUTA.",
            "cta": "JOACĂ ACUM"
        },
        "demo-kickup": {
            "slogan": "CÂTE JONGLERII POȚI FACE<br>ÎN 15 SECUNDE?",
            "slogan2": "ATINGE ECRANUL CÂND<br>MINGEA ATINGE PICIORUL.<br>ȚINE MINGEA IN AER. ",
            "cta": "JOACĂ ACUM"
        },
        "demo-save": {
            "slogan": "EȘTI PORTARUL.<br>ATINGE PENTRU A APĂRA.",
            "slogan2": "ALEGE-ȚI POZIȚIA<br>ÎNAINTE DE ȘUT.",
            "cta": "JOACĂ ACUM"
        },
        "game-shoot": {
            "instruction": "ALEGE-ȚI POZIȚIA. GLISEAZĂ PENTRU A ȘUTA.",
            "goal-callout": "Gol!",
            "miss-callout": "RATAT",
            "sub-title": "SCORUL TĂU",
            "circle-goal": "GOL",
            "circle-miss": "RATAT",
            "continue": "CONTINUĂ"
        },
        "game-dribble": {
            "continue": "CONTINUĂ",
            "sub-title": "Scorul Tău",
            "instruction": "ATINGE ECRANUL LA MOMENTUL POTRIVIT."
        },
        "game-save": {
            "sub-title": "SCORUL TĂU",
            "goal-callout": "MAI<br>ÎNCEARCĂ",
            "save-callout": "APĂRĂ!",
            "circle-goal": "GOL",
            "circle-save": "APĂRĂ",
            "status-save": "APĂRĂ",
            "status-goal": "GOL",
            "continue": "CONTINUĂ",
            "instruction": "ALEGE-ȚI POZIȚIA ÎNAINTE DE ȘUT.",
            "your-score": "SCORUL TĂU"
        },
        "outro": {
            "title": "UNDE EXISTĂ UN TEREN,<br>EXISTĂ O LEGENDĂ.",
            "sub-title": "JOACĂ DIN NOU SAU ÎNCEARCĂ<br>O NOUĂ PROVOCARE",
            "social-title": "PROVOACĂ-ȚI PRIETENII",
            "score-legend": "Scorul Legendei"
        },
        "share-message": `Ai fost provocat! Dovedește-ți abilitățile și arată ce poți—hai în curtea din spate și joacă "You Got This" de la adidas și încearcă să bați scorul meu. Scorul Legendei pe care trebuie să îl dobori: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        "exit-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-rom.jpg"
    },
    "dut": {
        "main-title": {
            "line-1": "YOU",
            "line-2": "GOT",
            "line-3": "THIS"
        },
        "back": "TERUG",
        "icons": {
            "icon-1": "shoot",
            "icon-2": "kick ups",
            "icon-3": "save"
        },
        "intro": {
            "summary": [
                "WAAR EEN VELD IS,",
                "IS EEN LEGEND.",
                "KIES JE CHALLENGE.",
                "LAAT JE SKILLS ZIEN."
            ],
        },
        "demo-shoot": {
            "slogan": "KIES JE PLEK.<br>SWIPE & SHOOT. ",
            "cta": "NU SPELEN"
        },
        "demo-kickup": {
            "slogan": "HOEVEEL KICK UPS KUN JE<br>DOEN IN 15 SECONDEN?",
            "slogan2": "TIK ALS DE BAL DE VOET RAAKT.<br>HOUD 'M HOOG.",
            "cta": "NU SPELEN"
        },
        "demo-save": {
            "slogan": "JIJ BENT DE KEEPER.<br>TAP VOOR DE SAVE.",
            "slogan2": "KIES JE PLEK VOODAT<br>HET SCHOT KOMT. ",
            "cta": "NU SPELEN"
        },
        "game-shoot": {
            "instruction": "KIES JE PLEK. SWIPE & SHOOT.",
            "goal-callout": "Goal!",
            "miss-callout": "MIS",
            "sub-title": "JOUW SCORE",
            "circle-goal": "GOAL",
            "circle-miss": "MIS",
            "continue": "DOORGAAN"
        },
        "game-dribble": {
            "continue": "DOORGAAN",
            "sub-title": "Jouw Score",
            "instruction": "TIME JE KICK UPS."
        },
        "game-save": {
            "sub-title": "JOUW SCORE",
            "goal-callout": "PROBEER<br>OPNIEUW",
            "save-callout": "SAVE",
            "circle-goal": "GOAL",
            "circle-save": "SAVE",
            "status-save": "SAVE!",
            "status-goal": "GOAL",
            "continue": "DOORGAAN",
            "instruction": "KIES JE PLEK VOORDAT HET SCHOT KOMT.",
            "your-score": "JOUW SCORE"
        },
        "outro": {
            "title": "WAAR  EEN VELD IS, IS EEN LEGEND.",
            "sub-title": "SPEEL  OPNIEUW OF PROBEER EEN NIEUWE CHALLENGE.",
            "social-title": "DAAG JE VRIENDEN UIT",
            "score-legend": "Legend Score"
        },
        "share-message": `Je bent uitgedaagd! Bewijs je skills en laat zien wat je in huis hebt—speel adidas' "You Got  This" en probeer mijn score te verslaan. Legende Score om te verslaan: $$$ #YouGotThis`,
        "share-url": "https://www.adidaslegends.com/",
        "exit-url": "https://www.adidaslegends.com/",
        'share-graphics': "images/pack-{pack}/share-dut.jpg"
    }
}

export default AdContent;

